import { i18n } from 'i18n'
import { IconName } from 'icon/types'

export const sortValues = ['popular', 'name', 'cheap', 'expensive', 'tsum_price_asc', 'tsum_price_desc', 'latest', 'oldest'] as const
export type Sort = typeof sortValues[number]

export function buildSort(sort: Sort): Record<string, 'asc' | 'desc'> | undefined {
  switch (sort) {
    case 'popular':
      return undefined
    case 'name':
      return { product_name: 'asc' }
    case 'cheap':
      return { prices: 'asc' }
    case 'expensive':
      return { prices: 'desc' }
    case 'tsum_price_asc':
      return { tsum_price: 'asc' }
    case 'tsum_price_desc':
      return { tsum_price: 'desc' }
    case 'oldest': 
      return { created_at: 'asc' }
    case 'latest': 
      return { created_at: 'desc' }
    default:
      return undefined
  }
}

export function getSortIconName(sort: Sort): IconName {
  switch (sort) {
    case 'popular':
      return 'swap_vert'
    case 'name':
      return 'abc'
    case 'cheap':
      return 'arrow_downward'
    case 'expensive':
      return 'arrow_upward'
    case 'tsum_price_asc':
      return 'arrow_downward'
    case 'tsum_price_desc':
      return 'arrow_upward'
    case 'oldest':
      return 'arrow_downward'
    case 'latest':
      return 'arrow_upward'
  }
}

export function getSortTitle(sort: Sort): string {
  switch (sort) {
    case 'popular':
      return i18n('demo.PopularSorting')
    case 'name':
      return i18n('demo.NameSorting')
    case 'cheap':
      return i18n('demo.CheapSorting')
    case 'expensive':
      return i18n('demo.ExpensiveSorting')
    case 'tsum_price_asc':
      return i18n('demo.TsumPriceAscSorting')
    case 'tsum_price_desc':
      return i18n('demo.TsumPriceDescSorting')
    case 'latest':
      return i18n('demo.LatestSorting')
    case 'oldest':
      return i18n('demo.OldestSorting')
    default:
      return ('' + sort || 'none').toUpperCase()
  }
}
